import './../lib/polyfills/Element.closest';
import './../lib/polyfills/CustomEvent';
// import iOsHoverFix from './modules/iOsHoverFix';
import initMap from './modules/map';
import scrollScreen from './modules/scrollScreen';
import scrollScreenInsidePages from './modules/scrollScreenInsidePages';
import fadeSlideshow from './modules/fadeSlideshow';
import secondSlideshow from './modules/secondSlideshow';
import activities from './modules/activities';
import news from './modules/news';
import vacancies from './modules/vacancies';
import subscribeVacancies from './modules/subscribeVacancies';
import language from './modules/language';
import search from './modules/search';

// iOsHoverFix();
initMap();
scrollScreen();
fadeSlideshow();
secondSlideshow();
scrollScreenInsidePages();
activities();
news();
vacancies();
subscribeVacancies();
language();
search();
